import { render } from "./TheHeaderNaviOfSubMenu.vue?vue&type=template&id=43685877&ts=true"
import script from "./TheHeaderNaviOfSubMenu.vue?vue&type=script&lang=ts"
export * from "./TheHeaderNaviOfSubMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__